<template>
    <div>
        <h3 class="font-weight-regular mb-3 submenu-title">{{$t('turblattBandseite')}}</h3>
        <v-radio-group v-model="leafSurfaceTypeOpeningSide" row mandatory>
            <template>
                <v-row>
                    <v-col cols="4" class="py-2"
                        v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_TOBERFL_BS').values"
                        :key="index">
                        <v-radio :label="valueDefinition.description" :value="valueDefinition.value"
                            @change="addCharacterisitc({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_BS'), valueDefinition: valueDefinition });handleRadioSelect({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_BS'), valueDefinition: valueDefinition })">
                        </v-radio>
                    </v-col>
                </v-row>
            </template>
        </v-radio-group>
        <v-row>
            <v-col cols="6">
                <div class="subtitle-2 mb-2">{{$t('turblattOberflache')}}</div>
                <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="doorSurfaceCharacteristicsDropDown" item-text="description"
                    :value="getRegisteredCharacteristicsValue(currentCharacteristicCode, doorLeafSurfaceContext).value"
                    @change="handleDoorSurfaceOptionSelect($event);">
                </v-select>

                <div class="body-2 pb-2" style="">
                    {{$t('sonderDekor')}}</div>
                <v-text-field  v-model="doorSurfaceSpecial"  :disabled="doorLeafSurfaceSpecialColorAvailability" dense outlined hide-details >
                </v-text-field>
               
            </v-col>
            <v-col cols="6">
                <div class="subtitle-2 mb-2">{{$t('falzfarbe')}}</div>
                <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="getCharacteristicAndValues('CUST_MM_FALZ_O_BS').values" item-text="description"
                   
                    :value="getRegisteredCharacteristicsValue('CUST_MM_FALZ_O_BS', doorLeafSurfaceContext).value"
                    @change="handleColorOptionSelect($event)">
                </v-select>

                <div class="body-2 pb-2" style="">
                    {{$t('sonderlackierung')}}</div>
                <v-text-field  v-model="specialDekor"  :disabled="falzFarbeSpecialColorAvailability" dense outlined hide-details >
                </v-text-field>
               
            </v-col>
        </v-row>
    </div>
    <!-- <div>
        <h1 class="title">Turblatt Bandseite </h1>
        <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
            <label v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_TOBERFL_BS').values" :key="index" 
                @click="addCharacterisitc({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_BS'), valueDefinition: valueDefinition });handleRadioSelect({ characteristic: getCharacteristicAndValues('KTU_MM_TOBERFL_BS'), valueDefinition: valueDefinition })" 
                :class="{ 'btn':true, 'btn-secondary':true, 'active': checkRadioValue(getCharacteristicAndValues('KTU_MM_TOBERFL_BS').code, valueDefinition.value)}"
                >
                    <div class="radio-btn">
                        <span></span>
                    </div>
                    <input type="radio" :name="valueDefinition.value" autocomplete="off"> {{ valueDefinition.description }}
            </label>
        </div>
        <div class="turblatt-wrap">
            <label class="input-label">Turblatt Oberfläche</label>
            <div class="full-dropdown">
                <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle dropdown-button"
                            type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue(currentCharacteristicCode, doorLeafSurfaceContext).value.description }}<span></span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <div class="simplebar" data-simplebar>
                            <div>
                                <a v-for="(valueDefinition, index) in doorSurfaceCharacteristicsDropDown" :key="index"
                                @click.prevent="handleDoorSurfaceOptionSelect(valueDefinition);" 
                                class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div :class="{'input-group' : true}">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Sonder Dekor / RAL Farbe / Furnier</span>
                </div>
                <input type="text" v-model="doorSurfaceSpecial" class="form-control" aria-label="Default" :disabled="doorLeafSurfaceSpecialColorAvailability"
                    aria-describedby="inputGroup-sizing-default" value="">
            </div>
        </div>
        <div class="turblatt-wrap">
            <label class="input-label">Falzfarbe</label>
                <div class="full-dropdown">
            <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle dropdown-button"
                            type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue('KTU_MM_FALZ_O_BS', doorLeafSurfaceContext).value.description }}<span></span>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div class="simplebar" data-simplebar>
                        <div>
                            <a v-for="(valueDefinition, index) in colorCharacteristicsDropDown" :key="index"
                                @click.prevent="handleColorOptionSelect({ characteristic: getCharacteristicAndValues('KTU_MM_FALZ_O_BS'), valueDefinition: valueDefinition });" 
                                class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            
            <div :class="{'input-group' : true}">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Sonderlackierung / RAL Farbe / angeben</span>
                </div>
                <input type="text" v-model="specialDekor" class="form-control" aria-label="Default" :disabled="falzFarbeSpecialColorAvailability"
                    aria-describedby="inputGroup-sizing-default" value="">
            </div>
        </div>
    </div> -->
</template>
<script>
    import Vue from 'vue';
    import {
        mapGetters
    } from 'vuex';
    import {
        mapActions
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../../configurator/DoorConfiguration';
    export default Vue.extend({
        name: 'DoorLeafOpeningSide',
        props: {
            characteristic: Object,
        },
        data() {
            return {
                doorLeafSurfaceContext: DoorConfiguration.DoorLeafSurface,
                selectedRadio: {},
                dependencies: [{
                        Key: 'DEKOR',
                        Value: 'CUST_MM_TUEROBERFL_BS',
                        SpecialValue: 'LLT120073'
                    },
                    {
                        Key: 'FURNIER',
                        Value: 'CUST_MM_TUEROBERFL_F_BS',
                        SpecialValue: 'LLT110022'
                    },
                    {
                        Key: 'LACKIERUNG',
                        Value: 'CUST_MM_TUEROBERFL_L_BS',
                        SpecialValue: 'LLT130010'
                    },
                ],
                doorSurfaceCharacteristicsDropDown: [],
                colorCharacteristicsDropDown: [],
                currentCharacteristicCode: '',
                blankCharacteristic: {},
                doorSurfaceSpecialValue: '',
                specialDekorValue: '',
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration',
                'getRegisteredCharacteristicsValue', 'getBlankCharacteristic', 'getProductId'
            ]),
            ...mapGetters('doorLeafSurfaceModule', ['getCharacteristicAndValues',
                'getNrOfValuesByCharacteristic', 'checkRadioValue'
            ]),
            doorSurfaceSpecial: {
                //getter
                get: function () {
                    this.doorSurfaceSpecialValue = this.getRegisteredCharacteristicsValue(
                        'KTU_MM_TUEROBERFL_SO_BS', this.doorLeafSurfaceContext).value.value;
                    return this.doorSurfaceSpecialValue;
                },
                //setter
                set: function (newValue) {
                    this.valueAddCharacteristic({
                        characteristicValue: this.getCharacteristicAndValues(
                            'KTU_MM_TUEROBERFL_SO_BS'),
                        value: newValue
                    });
                    this.doorSurfaceSpecialValue = newValue;
                }
            },

            specialDekor: {
                //getter
                get: function () {
                    this.specialDekorValue = this.getRegisteredCharacteristicsValue('KTU_MM_FALZ_O_SO_BS',
                        this.doorLeafSurfaceContext).value.value;
                    return this.specialDekorValue;
                },
                //setter
                set: function (newValue) {
                    this.valueAddCharacteristic({
                        characteristicValue: this.getCharacteristicAndValues('KTU_MM_FALZ_O_SO_BS'),
                        value: newValue
                    });
                    this.specialDekorValue = newValue;
                }
            },

            // Computed property that keeps track of special value for three characteristics
            doorLeafSurfaceSpecialColorAvailability: function () {
                const _this = this;
                let val = true;

                if (this.selectedRadio === 'DEKOR') {
                    val = _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_BS', this
                        .doorLeafSurfaceContext).value.value === 'LLT120060' ? false : true;
                } else if (this.selectedRadio === 'FURNIER') {
                    val = _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_F_BS', this
                        .doorLeafSurfaceContext).value.value === 'LLT110022' ? false : true;
                } else {
                    val = _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_L_BS', this
                        .doorLeafSurfaceContext).value.value === 'LLT130011' ? false : true;
                }

                return val;
            },

            // Computed property that keeps track of special value for falz farbe
            falzFarbeSpecialColorAvailability: {
                get: function() {
                    let falzValue = this.getRegisteredCharacteristicsValue('KTU_MM_FALZ_O_BS', this.doorLeafSurfaceContext).value.value;
                    return falzValue !== 'LLT130011';
                },
            },

            // leafSurfaceTypeOpeningSide: function () {
            //     return this.getRegisteredCharacteristicsValue('KTU_MM_TOBERFL_BS', this
            //         .doorLeafSurfaceContext).value.value;
            // },
            leafSurfaceTypeOpeningSide: {
                get: function () {
                    const _this = this;
                    return this.getRegisteredCharacteristicsValue('KTU_MM_TOBERFL_BS', this
                        .doorLeafSurfaceContext).value.value;
                },
                set: function(value) {
                }

            },
            leafSurfaceDekorOpeningSide: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_BS', this
                    .doorLeafSurfaceContext).value.value;
            },
            leafSurfaceFurnierOpeningSide: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_F_BS', this
                    .doorLeafSurfaceContext).value.value;
            },
            leafSurfaceLackierungOpeningSide: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_L_BS', this
                    .doorLeafSurfaceContext).value.value;
            },
            leafSurfaceSpecialOpeningSide: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_SO_BS', this
                    .doorLeafSurfaceContext).value.value;
            },
            falzBs: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue('KTU_MM_FALZ_BS', this
                    .doorLeafSurfaceContext).value.value;
            }
        },
        watch: {
            leafSurfaceTypeOpeningSide(leafSurfaceTypeOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicOpeningSide();
                this.selectedRadio = _this.getRegisteredCharacteristicsValue('KTU_MM_TOBERFL_BS', this
                    .doorLeafSurfaceContext).value.value;
                this.currentCharacteristicCode = this.dependencies.filter((item) => item.Key === this
                    .selectedRadio)[0].Value;
                this.doorSurfaceCharacteristicsDropDown = _this.getCharacteristicAndValues(this
                    .currentCharacteristicCode).values;
                this.setFalzOberflacheCounterOpeningSide();

            },
            leafSurfaceDekorOpeningSide(leafSurfaceDekorOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicOpeningSide();
            },
            leafSurfaceFurnierOpeningSide(leafSurfaceFurnierOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicOpeningSide();
            },
            leafSurfaceLackierungOpeningSide(leafSurfaceLackierungOpeningSide) {
                const _this = this;
                _this.setSchlagleisteDependantCharacteristicOpeningSide();
            },
            leafSurfaceSpecialOpeningSide(leafSurfaceSpecialOpeningSide) {
                const _this = this;
                _this.setSchlagleisteSpecialOpeningSide();
            },
            // Watcher for computed property doorLeafSurfaceSpecialColorAvailability that keeps track of special value for three characteristics
            doorLeafSurfaceSpecialColorAvailability(doorLeafSurfaceSpecialColorAvailability) {
                if (doorLeafSurfaceSpecialColorAvailability === true) {
                    this.doorSurfaceSpecial = '';
                }
            },
            // Watcher for computed property falzFarbeSpecialColorAvailability that keeps track of falz farbe characteristics
            falzFarbeSpecialColorAvailability(falzFarbeSpecialColorAvailability) {
                if (falzFarbeSpecialColorAvailability == true) {
                    this.specialDekor = '';
                }
            },

            falzBs(falzBs) {
                //Set falzGBS here!
                this.setFalzOberflacheCounterOpeningSide();
            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration']),
            ...mapActions('doorLeafSurfaceModule', ['addCharacterisitc', 'valueAddCharacteristic',
                'calculateDoorLeafSurfaceDekorOpeningSide',
                'calculateDoorLeafSurfaceLackierungOpeningSide',
                'calculateDoorLeafSurfaceFurnierOpeningSide',
                'calculateDoorLeafSurfaceFalz',
                'setSchlagleisteDependantCharacteristicOpeningSide', 'setSchlagleisteSpecialOpeningSide',
                'setFalzOberflacheCounterOpeningSide', 'setDoorLeafNonSelectedOptionsToEmpty'
            ]),

            handleRadioSelect(characteristic) {
                this.selectedRadio = characteristic.valueDefinition.value;
                this.initializeDoorSurfaceChars();
                this.currentCharacteristicCode = this.dependencies.filter((item) => item.Key === this
                    .selectedRadio)[0].Value;
                // const characteristicsWithEmptyValue = this.dependencies.filter((item) => item.Key !== this
                //     .selectedRadio);

                // this.setSelectedOptions(characteristic.valueDefinition.value);

                // characteristicsWithEmptyValue.forEach(element => {
                //     console.log(element)
                //     const val = _this.getCharacteristicAndValues(element.Value).values.filter((item) =>
                //         item.value === '0')[0];
                //     _this.addCharacterisitc({
                //         characteristic: _this.getCharacteristicAndValues(element.Value),
                //         valueDefinition: val
                //     });
                // });

                this.doorSurfaceCharacteristicsDropDown = this.getCharacteristicAndValues(this
                    .currentCharacteristicCode).values;

                //Change TurFalzOberflacheGBS
                this.setFalzOberflacheCounterOpeningSide();
                this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_FURNIEROBERFL_BS");
                this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_GLANZGRAD_BS");


            },

            handleDoorSurfaceOptionSelect(event) {
                this.addCharacterisitc({
                    characteristic: this.getCharacteristicAndValues(this.currentCharacteristicCode),
                    valueDefinition: event
                });

                if (this.selectedRadio === 'DEKOR') {
                    this.calculateDoorLeafSurfaceDekorOpeningSide();
                }
                else if (this.selectedRadio === 'LACKIERUNG') {
                    this.calculateDoorLeafSurfaceLackierungOpeningSide();
                }
                else if (this.selectedRadio === 'FURNIER') {
                    this.calculateDoorLeafSurfaceFurnierOpeningSide();
                }


                this.setFalzOberflacheCounterOpeningSide();
            },

            initializeDoorSurfaceChars() {
                let selectFurnierValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_BS').values;
                let selectLackierungValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_BS').values;
                let selectDekorValues = this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_BS').values;

                let selectedFurnierValue = this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_F_BS', this.doorLeafSurfaceContext).value.value
                let selectedLackierungValue = this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_L_BS', this.doorLeafSurfaceContext).value.value
                let selectedDekorValue = this.getRegisteredCharacteristicsValue('KTU_MM_TUEROBERFL_BS', this.doorLeafSurfaceContext).value.value

                if(this.selectedRadio === 'DEKOR'){
                    let LLTToSetDekor = selectedLackierungValue === 0 ? 'LLT120073' : selectedDekorValue
                    let valueToSetDekor = selectDekorValues.find(x => x.value === LLTToSetDekor);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_BS'), valueDefinition: valueToSetDekor });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_BS'), valueDefinition: valueToSetLackierung });
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_BS'), valueDefinition: valueToSetFurnier });
                }
                else if (this.selectedRadio === 'FURNIER') {
                    let valueToSetDekor = selectDekorValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_BS'), valueDefinition: valueToSetDekor });
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_BS'), valueDefinition: valueToSetLackierung });
                    let LLTToSetFurnier = selectedLackierungValue === 0 ? 'LLT110001' : selectedFurnierValue
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === LLTToSetFurnier);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_BS'), valueDefinition: valueToSetFurnier });
                }
                else if (this.selectedRadio === 'LACKIERUNG') {
                    let LLTToSetDekor = selectedLackierungValue === 0 ? 'LLT120077' : selectedDekorValue
                    let valueToSetDekor = selectDekorValues.find(x => x.value === LLTToSetDekor);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_BS'), valueDefinition: valueToSetDekor });
                    let LLTToSetLackierung = selectedLackierungValue === 0 ? 'LLT130010' : selectedLackierungValue
                    let valueToSetLackierung = selectLackierungValues.find(x => x.value === LLTToSetLackierung);
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_L_BS'), valueDefinition: valueToSetLackierung });
                    let valueToSetFurnier = selectFurnierValues.find(x => x.value === '0');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_F_BS'), valueDefinition: valueToSetFurnier });
                }
            },

            handleColorOptionSelect(valueDefinition) {
                this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('CUST_MM_FALZ_O_BS'), valueDefinition: valueDefinition });
                // const _this = this;
                // _this.addCharacterisitc({
                //     characteristic: _this.getCharacteristicAndValues('KTU_MM_FALZ_O_BS'),
                //     valueDefinition: characteristic.valueDefinition
                // });
                this.calculateDoorLeafSurfaceFalz();
                this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_FALZ_BS");
                this.setFalzOberflacheCounterOpeningSide();
                this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_D2_METALL_O");
            },

        },
        mounted() {
            const _this = this;
            this.calculateDoorLeafSurfaceFalz();
            _this.setSchlagleisteDependantCharacteristicOpeningSide();
            this.selectedRadio = _this.getRegisteredCharacteristicsValue('KTU_MM_TOBERFL_BS', this
                .doorLeafSurfaceContext).value.value;
            this.currentCharacteristicCode = this.dependencies.filter((item) => item.Key === this
                .selectedRadio)[0].Value;
            this.doorSurfaceCharacteristicsDropDown = _this.getCharacteristicAndValues(this
                .currentCharacteristicCode).values;
            // this.colorCharacteristicsDropDown = _this.getCharacteristicAndValues('KTU_MM_FALZ_O_BS').values;
            this.initializeDoorSurfaceChars()
            const isAvailable = this.falzFarbeSpecialColorAvailability
            if (isAvailable)
                this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_TUEROBERFL_SO_BS'), value: "" })
            // this.setSelectedOptions(this.selectedRadio);
        }
    });
</script>
<style scoped>

</style>